import { Image } from "antd";
import { useEffect, useState, type CSSProperties } from "react";
import { api, unwrap } from "@/api/client";

// One fetch per SKU per page load: the picture as an object URL, or null.
const cache = new Map<string, Promise<string | null>>();

function picture(skuId: string): Promise<string | null> {
  let p = cache.get(skuId);
  if (!p) {
    p = unwrap(api.GET("/v1/skus/{skuID}/picture", { params: { path: { skuID: skuId } }, parseAs: "blob" }))
      .then((b) => URL.createObjectURL(b as Blob))
      .catch(() => null);
    cache.set(skuId, p);
  }
  return p;
}

/**
 * An SKU's picture for the floor (the warehouse's photo first, else the
 * product's or the listing's), small, enlarged on click; a blank tile when
 * it has none.
 */
export function SkuThumb({ skuId, size = 40 }: { skuId?: string | null; size?: number }) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!skuId) return;
    let live = true;
    void picture(skuId).then((u) => live && setUrl(u));
    return () => {
      live = false;
    };
  }, [skuId]);
  const box: CSSProperties = { width: size, height: size, borderRadius: 6, objectFit: "cover", flex: "none", background: "var(--ant-color-fill-tertiary)" };
  if (!url) return <div style={box} />;
  return <Image src={url} width={size} height={size} style={box} alt="" />;
}
